import PublicationGroupDirector from './PublicationGroupDirector';

export default PublicationGroupDirector;
